










import { Component, Vue } from 'vue-property-decorator';

import ThreatList from '../components/ThreatList.vue';
import { AssessmentInstance } from '../models';
import { httpGet } from '../utils';

@Component({
  components: {
    ThreatList,
  },
})
export default class ThreatsView extends Vue {
  private isLoading: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private assessment: AssessmentInstance | null = null;

  private created() {
    this.isLoading = true;
    const url = `${process.env.VUE_APP_API_HOST}/assessments/${this.$route.params.assessmentId}` +
      `/sections/${this.$route.params.sectionId}/threats`;
    httpGet<AssessmentInstance>(url)
      .then((assessment) => {
        this.assessment = assessment;
      }).catch((error) => {
        this.errorMessage = error.message;
        this.isError = true;
      }).then(() => {
        this.isLoading = false;
      });
  }
}
